import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1b201e1e&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b201e1e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b201e1e')) {
      api.createRecord('1b201e1e', component.options)
    } else {
      api.reload('1b201e1e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1b201e1e&scoped=true&", function () {
      api.rerender('1b201e1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/logistics/quality-personnel-input/modules/table-list/index.vue"
export default component.exports